import { useTranslation } from "@redotech/redo-i18n";
import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { SentFromEmailState } from "@redotech/redo-return-ui/flows/rules/conditions/sent-from-email";
import { RedoTagInputField } from "@redotech/redo-web/arbiter-components/input/redo-tag-input-field";
import { RedoSingleSelectDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-single-select-dropdown-input";
import { memo, useState } from "react";
import { commitPendingTagInput } from "../commit-pending-tag-input";

export const SentFromEmailDetails = memo(function SentFromEmailDetails({
  state,
  setState,
  disabled,
}: ConditionTypeDetailsProps<SentFromEmailState>) {
  const { t } = useTranslation();
  const [inputValue, setInputValue] = useState("");

  const matchModeOptions = [
    {
      id: "INCLUDES",
      type: "text" as const,
      text: t("Email contains"),
      value: "INCLUDES",
    },
    {
      id: "IS_EXACTLY",
      type: "text" as const,
      text: t("Email matches exactly"),
      value: "IS_EXACTLY",
    },
  ];

  const selectedMatchMode = matchModeOptions.find(
    (option) => option.id === state.matchMode,
  );

  const commitPendingInput = () => {
    if (disabled) {
      return;
    }
    const emails = commitPendingTagInput(state.emails, inputValue);
    if (!emails) {
      return;
    }
    setState({ ...state, emails: emails as typeof state.emails });
    setInputValue("");
  };

  return (
    <>
      <RedoTagInputField
        inputValue={inputValue}
        label={t("Sender email address(es)")}
        onBlur={commitPendingInput}
        placeholder={t("Enter email addresses")}
        setInputValue={setInputValue}
        setTags={(emails) => {
          const uniqueEmails = Array.from(new Set(emails));
          setState({ ...state, emails: uniqueEmails as typeof state.emails });
        }}
        state={disabled ? "disabled" : "default"}
        tags={state.emails.map((email) => ({ text: email }))}
      />
      <RedoSingleSelectDropdownInput
        disabled={disabled}
        label={t("Match mode")}
        options={matchModeOptions}
        optionSelected={({ item }) => {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
          setState({ ...state, matchMode: item.id as typeof state.matchMode });
        }}
        selectedItem={selectedMatchMode}
      />
    </>
  );
});
